import { apiFetch } from "./client";

export type KonusFormData = {
  booking_id: number;
  buchungsreferenz: string | null;
  gruppenname: string;
  check_in: string;
  check_out: string;
  einheiten: string[];
  personen_ab_16: number;
  kinder_6_bis_15: number;
  kinder_unter_6: number;
  anrede: string;
  vorname: string;
  nachname: string;
  gruppenleiter_geburtsdatum: string | null;
};

export type KonusProposalIn = {
  personen_ab_16: number;
  kinder_6_bis_15: number;
  kinder_unter_6: number;
  anrede: string;
  vorname: string;
  nachname: string;
  geburtsdatum: string;
  adresse_strasse: string;
  adresse_hausnummer: string;
  adresse_plz: string;
  adresse_ort: string;
  adresse_land: string;
};

export function fetchKonusFormData(token: string): Promise<KonusFormData> {
  return apiFetch<KonusFormData>(`/api/public/booking/konus/${encodeURIComponent(token)}`);
}

export function submitKonusForm(token: string, data: KonusProposalIn): Promise<{ detail: string }> {
  return apiFetch<{ detail: string }>(`/api/public/booking/konus/${encodeURIComponent(token)}`, {
    method: "POST",
    body: data as unknown as Record<string, unknown>,
  });
}
